import React from 'react';
import classNames from 'clsx';
import type { MenuItemProps } from '@wix/editor-elements-definitions';
import type { Direction } from '@wix/editor-elements-common-utils';
import type { IMenuItemSDKAction } from '@wix/editor-elements-corvid-utils';
import type {
  DropdownAnimationNameType,
  MenuPreviewStateMap,
} from '../../../Menu.types';
import type { AnimationState } from '../MenuItem/useAnimationState';
import { MenuItemContext } from '../../../../../common/menu/MenuItemContext';
import { Dropdown } from '../Dropdown';
import classes from '../MenuItem/style/MenuItem.module.scss';

export type VerticalDropdownProps = {
  isOpen: boolean;
  onEscKeyDown: () => void;
  item: MenuItemProps & {
    forceOpen?: boolean;
    children?: React.ReactNode | undefined;
  };
  currentItem?: MenuItemProps;
  partToPreviewStateMap?: MenuPreviewStateMap;
  dropdownAnimationState: AnimationState<DropdownAnimationNameType>;
  direction?: Direction;
  itemClassName?: string;
  subItemClassName?: string;
  onItemClick?: IMenuItemSDKAction;
  onItemMouseIn?: IMenuItemSDKAction;
  onItemMouseOut?: IMenuItemSDKAction;
  onItemDblClick?: IMenuItemSDKAction;
};

export const VerticalDropdown = (props: VerticalDropdownProps) => {
  return (
    <MenuItemContext.Provider
      value={{
        onEscKeyDown: props.onEscKeyDown,
        item: props.item,
        currentItem: props.currentItem,
        dropdownAnimationState: props.dropdownAnimationState,
      }}
    >
      <Dropdown
        item={props.item}
        menuOrientation="vertical"
        className={classNames(
          classes.verticalDropdownDisplayWrapper,
          props.isOpen && classes.expandedDropdown,
        )}
        partToPreviewStateMap={props.partToPreviewStateMap}
        onItemClick={props.onItemClick}
        onItemMouseIn={props.onItemMouseIn}
        onItemMouseOut={props.onItemMouseOut}
        onItemDblClick={props.onItemDblClick}
      />
    </MenuItemContext.Provider>
  );
};
